<!-- Dialog title and close button -->
<div class="bottom-shadow dialog-title-padding">
    <div class="page-title">
        <div>
            <h3 class="lato-regular">Notification</h3>
        </div>
        <div>
            <mat-icon mat-dialog-close class="cursor">close</mat-icon>
        </div>
    </div>
</div>
<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20" class="pt-20" *ngIf="notification">
    <div *ngIf="notification.length === 0" fxLayout="row wrap" fxLayoutAlign="center center" class="width">
        <mat-card class="width box-shadow">
            <mat-card-content>
                <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5">
                    <p class="font-weight-600 font-size-18">No notifications</p>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div *ngIf="notification.length > 0">
        <div fxLayout="row wrap" fxLayoutAlign="center center" class="width cursor" *ngFor="let test of notification">
            <mat-card [ngClass]="{'bg-unseen': test.status === 0}" class="width box-shadow"
                (click)="handleNotificationClick(test)">
                <mat-card-content>
                    <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5">
                        <p class="font-weight-600 font-size-18 ">{{test.title}}</p>
                        <p class="font-weight-500 font-size-16 "> {{test.message}}</p>
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100-2">
                            <p class="font-weight-600 font-size-14 ">{{test.created_at | date:'MM/dd/yyyy, h:mm a'}}</p>
                            <img src="../../../../assets/images/icons/read.png" *ngIf="test.status === 1">
                            <img src="../../../../assets/images/icons/unread.png" *ngIf="test.status === 0">
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>